import { z } from 'zod';

import { textRegex } from '~/utils/regexp';

export const CUSTOMER_NAME_MIN_LENGTH = 2;
export const CUSTOMER_NAME_MAX_LENGTH = 22;

export const createNameValidation = (t: (key: string) => string) =>
  z
    .string()
    .min(CUSTOMER_NAME_MIN_LENGTH, { message: t('nameTooShort') })
    .regex(textRegex, { message: t('invalidCharacters') });

export const createOnboardingValidationSchema = (t: (key: string) => string) =>
  z.object({
    name: createNameValidation(t),
    email: z.string().min(1).email(),
  });

export type OnboardingSchema = z.infer<
  ReturnType<typeof createOnboardingValidationSchema>
>;
